module.exports = __webpack_public_path__ + "1795bf3be12920818ba03c4a7d2c3e4e.svg";